import React from 'react';
import {
	MimaButton,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
} from '../../components';
import { Formik } from 'formik';

const AddRequest = ({
	closeModal,
	loading,
	design,
	validationSchema,
	onSubmit,
}) => {
	return (
		<Modal closeModal={closeModal}>
			<Formik
				initialValues={{
					fullname: '',
					mobile: '',
					email: '',
					note: '',
					quantity: 0,
					withMaterial: true,
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<>
						<MimaText
							variant="subtitleBold"
							color="var(--color-primary)"
							mb={4}
							width={30}
							align="center">
							{`Request ${design.name} Design`}
						</MimaText>
						<MimaInput
							labelTitle="Full Name"
							type="text"
							placeholder="Firstname Middlename Lastname"
							id="fullname"
							name="fullname"
							value={values.fullname}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.fullname}
							touched={touched.fullname}
						/>

						<MimaInput
							labelTitle="Phone Number"
							type="tel"
							placeholder="Enter your mobile number"
							id="mobile"
							name="mobile"
							value={values.mobile}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.mobile}
							touched={touched.mobile}
						/>

						<MimaInput
							labelTitle="Email"
							type="text"
							placeholder="Enter your Email"
							id="email"
							name="email"
							value={values.email}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.email}
							touched={touched.email}
						/>

						<MimaTextArea
							labelTitle="Note"
							placeholder="Note"
							name="note"
							id="note"
							value={values.note}
							onChange={handleChange}
							onBlur={handleBlur}
							touched={touched.note}
							error={errors.note}
						/>

						<MimaButton
							title="Request Design"
							type="submit"
							loading={loading}
							onClick={handleSubmit}
							variant="form"
							width={38}
						/>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default AddRequest;
